<div class="form-group">
    <mat-form-field>
        <input #inputCalendar matInput readonly [value]="getInputValue()">
        <mat-placeholder class="calendar-placeholder">{{this.label}}</mat-placeholder>
            <mat-icon matSuffix class="date-picker-trigger" (click)="openModal()"><i class="fas fa-calendar-day"></i></mat-icon>
    </mat-form-field>
  </div>